module.exports = __webpack_public_path__ + "img/header-weddingRingsModern@2x.02f1f04.webp";